import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicProgrammedIO = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Programmed I/O"
      videos={[
        "https://www.youtube.com/embed/-VdpvjezNSk"
      ]}
      takeaways={[
        { text: "Learn the flowchart and block diagram." },
        { text: "Understand the procedure of Programmed I/O." },
        { text: "Know the pros and cons of this method." }
      ]}
      questions={[]} // No questions provided
      exampleVideos={[]} // No example videos provided
    />
);
}

export default ModuleSubtopicProgrammedIO;
